/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useEffect } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import StepNumber from "./common/StepNumber.vue";
import { useDtfStore } from "./store";
import "./PuffColorSelector.scss";
import { renderList } from "common/vue/render-list";

export default function PuffColorSelector({ label, ...restProps }: any) {
  const colors = [
    { label: "white", value: "#FFFFFF" },
    { label: "black", value: "#000000" },
    { label: "red", value: "#D50132" },
    { label: "orange", value: "#FA4617" },
    { label: "gold", value: "#FEB414" },
    { label: "yellow", value: "#FFDD04" },
    { label: "green", value: "#007A00" },
    { label: "blue", value: "#1261A9" },
    { label: "purple", value: "#432F92" },
    { label: "teal", value: "#008080" },
    { label: "mint", value: "#B6E4E4" },
    { label: "lavender", value: "#C7B1EA" },
    { label: "coral", value: "#FDA398" },
    { label: "pink", value: "#EE529C" },
    { label: "denim", value: "#1C5C82" },
    { label: "brown", value: "#4D3525" }
  ];

  const store = useDtfStore();

  function artwork() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.artworks?.[0];
  }

  function showBorderUI() {
    // @ts-expect-error TS(4111): Property 'showStepsUI' comes from an index signatu... Remove this comment to see the full error message
    return store.showStepsUI;
  }

  function handleSelect(color: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.changePuffColor({ color });
  }

  const artworkUrl = artwork()?.url;
  const artworkEnhancementTier = artwork()?.enhancementTier;

  useEffect(() => {
    const art = artwork();
    if (art && !art.isFile) {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const color = art.color || colors[0].value;
      handleSelect(art.url ? color : null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artworkUrl]);

  useEffect(() => {
    const art = artwork();
    if (art) {
      const { color } = art;
      if (color) {
        handleSelect(color);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artworkEnhancementTier]);

  const art = artwork();
  const borderUI = showBorderUI();

  return (
    <div
      {...restProps}
      className={cn("puff-color-selector", {
        "puff-color-selector--with-border": borderUI
      })}
    >
      {label ? (
        <>
          {borderUI ? (
            <StepNumber stepNumber="2" content={label} data-testid="step-number" />
          ) : (
            <div className="puff-color-selector__label">{label}</div>
          )}
        </>
      ) : null}
      <div className="puff-color-selector__items">
        {renderList(colors, color => (
          <div
            className={cn("puff-color-selector__item", {
              "puff-color-selector__item--selected": art?.color === color.value
            })}
            key={color.label}
            onClick={() => {
              handleSelect(color.value);
            }}
            data-testid="puff-color-selector-div"
          >
            <div
              className="puff-color-selector__color"
              style={{
                backgroundColor: color.value
              }}
            >
              {art?.color === color.value ? (
                <UseSvg
                  className={cn(
                    "puff-color-selector__checkbox",
                    `puff-color-selector__checkbox--${color.label}`
                  )}
                  icon="checkbox"
                  width="40"
                  height="40"
                  data-testid="puff-color-selector-checkbox"
                />
              ) : null}
            </div>{" "}
            {color.label}
          </div>
        ))}
      </div>
    </div>
  );
}
